export class IDictionary {
    header: {
        menuLabelSection: string;
    };

    footer: {
        doNotSellOrShareMyInformation: string;
    };

    rewards: {
        rewardsFormFooter: {
            emailLabel: string;
            firstNameLabel: string;
            lastNameLabel: string;
            phoneNumberLabel: string;
            signUpLabel: string;
            zipCodeLabel: string;
            birthdateLabel: string;
        };
    };

    constructor() {
        this.header = {
            menuLabelSection: '',
        };

        this.footer = {
            doNotSellOrShareMyInformation: '',
        };

        this.rewards = {
            rewardsFormFooter: {
                emailLabel: '',
                firstNameLabel: '',
                lastNameLabel: '',
                phoneNumberLabel: '',
                signUpLabel: '',
                zipCodeLabel: '',
                birthdateLabel: '',
            },
        };
    }

    public static Make(obj: any): IDictionary {
        if (!obj) return new IDictionary();

        const dictionary = new IDictionary();

        dictionary.header.menuLabelSection = obj['header/menu-label-section'];

        dictionary.footer.doNotSellOrShareMyInformation = obj['footer/do-not-sell-or-share-my-information'];

        dictionary.rewards.rewardsFormFooter.emailLabel = obj['rewards/rewards-form-footer/email-address'];
        dictionary.rewards.rewardsFormFooter.firstNameLabel = obj['rewards/rewards-form-footer/first-name'];
        dictionary.rewards.rewardsFormFooter.lastNameLabel = obj['rewards/rewards-form-footer/last-name'];
        dictionary.rewards.rewardsFormFooter.phoneNumberLabel = obj['rewards/rewards-form-footer/phone-number'];
        dictionary.rewards.rewardsFormFooter.signUpLabel = obj['rewards/rewards-form-footer/sign-up'];
        dictionary.rewards.rewardsFormFooter.zipCodeLabel = obj['rewards/rewards-form-footer/zip-code'];
        dictionary.rewards.rewardsFormFooter.birthdateLabel = obj['rewards/rewards-form-footer/birth-date'];

        return dictionary;
    }
}
